import { Box, SxProps, Theme } from "@mui/material";
import Image from "next/image";

export default function InlineLogo({
  name,
  logoSrc,
  size = 20,
  withName = true,
  sx,
}: {
  name: string;
  logoSrc: string;
  size?: number;
  withName?: boolean;
  sx?: SxProps<Theme>;
}) {
  return (
    <>
      <Box
        sx={{
          mr: withName ? 0.5 : 0,
          verticalAlign: "middle",
          display: "inline-block",
          ...sx,
        }}
      >
        <Image width={size} height={size} alt={`${name} logo`} src={logoSrc} />
      </Box>
      {withName && name}
    </>
  );
}
